"use client"

import { Dock } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DockIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DockIcon = component(Icon)({ as: Dock })
